import React from 'react';
import { Input } from './ui/Input';
import { Select } from './ui/Select';
import { Button } from './ui/Button';
import { Trash2 } from 'lucide-react';
export interface TaxSlab {
  id: string;
  taxType: 'Percentage' | 'Fixed' | 'Fixed + Percentage';
  taxValue: string;
  fixedAmount?: string;
  slabLow: string;
  slabHigh: string;
  filerStatus: string;
  glAccount: string;
  frequency: string;
}
interface TaxSlabRowProps {
  slab: TaxSlab;
  index: number;
  onChange: (id: string, updates: Partial<TaxSlab>) => void;
  onRemove: (id: string) => void;
}
export function TaxSlabRow({
  slab,
  index,
  onChange,
  onRemove
}: TaxSlabRowProps) {
  return <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 relative animate-in fade-in slide-in-from-bottom-2 duration-300" data-id="element-1123">
      <div className="absolute -top-3 left-4 bg-gray-100 px-2 py-0.5 rounded text-xs font-medium text-gray-500 border border-gray-200" data-id="element-1124">
        Slab {index + 1}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4" data-id="element-1125">
        {/* Row 1: Type, Value, and Slab Range */}
        <div className="md:col-span-3" data-id="element-1126">
          <Select label="Tax Type" value={slab.taxType} onChange={e => onChange(slab.id, {
          taxType: e.target.value as any
        })} options={[{
          value: 'Percentage',
          label: 'Percentage'
        }, {
          value: 'Fixed',
          label: 'Fixed Amount'
        }, {
          value: 'Fixed + Percentage',
          label: 'Fixed + Percentage'
        }]} data-id="element-1127" />
        </div>

        <div className="md:col-span-2" data-id="element-1128">
          <Input label={slab.taxType === 'Fixed' ? 'Amount' : 'Percentage (%)'} type="number" value={slab.taxValue} onChange={e => onChange(slab.id, {
          taxValue: e.target.value
        })} placeholder={slab.taxType === 'Fixed' ? '100' : '18'} data-id="element-1129" />
        </div>

        {slab.taxType === 'Fixed + Percentage' && <div className="md:col-span-2" data-id="element-1130">
            <Input label="Fixed Amount" type="number" value={slab.fixedAmount || ''} onChange={e => onChange(slab.id, {
          fixedAmount: e.target.value
        })} placeholder="100" data-id="element-1131" />
          </div>}

        <div className={slab.taxType === 'Fixed + Percentage' ? 'md:col-span-2' : 'md:col-span-2'} data-id="element-1132">
          <Input label="Slab Low" type="number" value={slab.slabLow} onChange={e => onChange(slab.id, {
          slabLow: e.target.value
        })} placeholder="0" data-id="element-1133" />
        </div>

        <div className={slab.taxType === 'Fixed + Percentage' ? 'md:col-span-2' : 'md:col-span-2'} data-id="element-1134">
          <Input label="Slab High" type="number" value={slab.slabHigh} onChange={e => onChange(slab.id, {
          slabHigh: e.target.value
        })} placeholder="Unlimited" data-id="element-1135" />
        </div>

        {/* Row 2: Frequency, Filer Status, GL Account, Remove Button */}
        <div className="md:col-span-2" data-id="element-1136">
          <Select label="Frequency" value={slab.frequency || 'monthly'} onChange={e => onChange(slab.id, {
          frequency: e.target.value
        })} options={[{
          value: 'daily',
          label: 'Daily'
        }, {
          value: 'weekly',
          label: 'Weekly'
        }, {
          value: 'monthly',
          label: 'Monthly'
        }, {
          value: 'yearly',
          label: 'Yearly'
        }]} data-id="element-1137" />
        </div>

        <div className="md:col-span-2" data-id="element-1138">
          <Select label="Filer / Non-Filer" value={slab.filerStatus} onChange={e => onChange(slab.id, {
          filerStatus: e.target.value
        })} options={[{
          value: 'Filer',
          label: 'Filer'
        }, {
          value: 'Non-Filer',
          label: 'Non-Filer'
        }, {
          value: 'Both',
          label: 'Both'
        }]} data-id="element-1139" />
        </div>

        <div className="md:col-span-7" data-id="element-1140">
          <Select label="GL Account" value={slab.glAccount} onChange={e => onChange(slab.id, {
          glAccount: e.target.value
        })} options={[{
          value: '2100',
          label: '2100 - Tax Payable - Service Tax'
        }, {
          value: '2200',
          label: '2200 - Tax Payable - FED'
        }, {
          value: '2300',
          label: '2300 - Tax Payable - VAT'
        }, {
          value: '2400',
          label: '2400 - Tax Payable - Withholding'
        }]} data-id="element-1141" />
        </div>

        <div className="md:col-span-1 flex items-end justify-end" data-id="element-1142">
          <Button variant="ghost" size="sm" onClick={() => onRemove(slab.id)} className="text-red-600 hover:text-red-700 hover:bg-red-50" title="Remove Slab" data-id="element-1143">
            <Trash2 className="h-4 w-4" data-id="element-1144" />
          </Button>
        </div>
      </div>
    </div>;
}